import{useState as n}from"react";const r=e=>{const[o,t]=n(!!e);return[o,()=>t(!o),()=>t(!0),()=>t(!1)]};var g=r;export{g as default};
//# sourceMappingURL=use-toggle.js.map
